import { combineReducers } from 'redux';
import BookingReducer from './BookingReducer';
import CommonReducer from './CommonReducer';
import ShopReducer from './ShopReducer';
import UserReducer from './UserReducer';

const reducers = combineReducers({
  common: CommonReducer,
  booking: BookingReducer,
  shop: ShopReducer,
  user: UserReducer,
});

export default reducers;
